<risr-resource-wrapper [resource]="formResource">
    @if (formResource.hasValue()) {
        @let form = formResource.value();
        <form [formGroup]="form.form" (ngSubmit)="submit(form)">
            <mat-card>
                <mat-card-content>
                    <risr-form-renderer [risrForm]="form" />
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button color="primary">{{buttonLabel()}}</button>
                </mat-card-actions>
            </mat-card>
        </form>
    }
</risr-resource-wrapper>